import { GetStrTotal } from './GetStrTotal';

export const CountDatas = (label, datas) => {
    const count = {};
    const collection = {};
    const name = label.includes('-') ? label.split('-')[1] : label;
    if (datas.errno) return collection;
    switch (label) {
        default:
        case 'family-attraction':
        case 'family-personnage':
            for (const e of datas) {
                count[e.fslug] = count[e.fslug] ? count[e.fslug] + 1 : 1;
                collection[e.fslug] = `${count[e.fslug]} ${GetStrTotal(name, count[e.fslug])}`;
            }
            break;
        case 'category-attraction':
            for (const e of datas) {
                count[e.cslug] = count[e.cslug] ? count[e.cslug] + 1 : 1;
                collection[e.cslug] = `${count[e.cslug]} ${GetStrTotal(name, count[e.cslug])}`;
            }
            break;
        case 'category-archive':
            for (const e of datas) {
                count[e.cslug] = count[e.cslug] ? count[e.cslug] + 1 : 1;
                collection[e.cslug] = `${count[e.cslug]} ${GetStrTotal(name, count[e.cslug])}`;
            }
            break;
        case 'category-rencontre':
            for (const e of datas) {
                count[e.catslug] = count[e.catslug] ? count[e.catslug] + 1 : 1;
                collection[e.catslug] = `${count[e.catslug]} ${GetStrTotal(name, count[e.catslug])}`;
            }
            break;
        case 'univers-attraction':
        case 'univers-personnage':
            for (const e of datas) {
                count[e.uslug] = count[e.uslug] ? count[e.uslug] + 1 : 1;
                collection[e.uslug] = `${count[e.uslug]} ${GetStrTotal(name, count[e.uslug])}`;
            }
            break;
        case 'origin-attraction':
        case 'origin-personnage':
            for (const e of datas) {
                count[e.oslug] = count[e.oslug] ? count[e.oslug] + 1 : 1;
                collection[e.oslug] = `${count[e.oslug]} ${GetStrTotal(name, count[e.oslug])}`;
            }
            break;
    }
    return collection;
}